module.exports = __webpack_public_path__ + "static/img/ent-38.f745ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-38.jpg
// module id = yy6q
// module chunks = 51